/**
 * Mutación que carga las opciones de inflamabilidad en el formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} opcInflamabilidad contiene las opciones de inflamabilidad.
 */
export function cargarOpcInflamabilidad(state, opcInflamabilidad) {
    opcInflamabilidad.forEach(element => {
        state.opcInflamabilidad.push({
            value: element.id,
            text: element.lista
        })

    });
        /* for(var i=0; i<opcInflamabilidad.length;i++){
            state.opcInflamabilidad.push({value: opcInflamabilidad[i].id, text: opcInflamabilidad[i].lista });
        } */
}

/**
 * Mutación que carga las opciones de salud en el formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} opcSalud contiene las opciones de salud.
 */
export function cargarOpcSalud(state, opcSalud) {
    for (var i = 0; i < opcSalud.length; i++) {
        state.opcSalud.push({ value: opcSalud[i].id, text: opcSalud[i].lista });
    }
}

/**
 * Mutación que carga las opciones físicas en el formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} opcPelFisico contiene las opciones físicas.
 */
export function cargarOpcFisicos(state, opcPelFisico) {
    for (var i = 0; i < opcPelFisico.length; i++) {
        state.opcPelFisico.push({ value: opcPelFisico[i].id, text: opcPelFisico[i].lista });
    }
}

/**
 * Mutación que carga las opciones en el formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} opcPelFisico contiene las opciones físicas.
 */
export function cargarOpciones(state, opciones) {
    opciones.forEach(element => {
        if ((state.opcInflamabilidad.length != 5)) {
            state.opcInflamabilidad.push({
                value: element.id,
                text: element.lista
            })
        }
        if ((state.opcSalud.length != 5)) {
            state.opcSalud.push({
                value: element.id,
                text: element.lista
            })
        }
        if ((state.opcPelFisico.length != 5)) {
            state.opcPelFisico.push({
                value: element.id,
                text: element.lista
            })
        }
        state.opciones.push({
            value: element.id,
            text: element.lista
        })

    });
}


/**
 * Mutación que carga la información guardada de HMIS en el formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} hmis contiene la información guardada de HMIS.
 */
export function setHmis(state, datos) {
    state.selectedHmis.opsalud = datos.salud;
    state.selectedHmis.ambiental = datos.ambiental;
    state.selectedHmis.saludHMIS = datos.RadioProdSalud[0];
    state.selectedHmis.inflamabilidad = datos.inflamabilidad;
    state.selectedHmis.fisico = datos.peligrofisico;
    state.selectedHmis.peligrosHMIS = datos.RadioPeligroFisico[0];
    state.selectedHmis.letrasHMIS = datos.RadioProteccionMayuscula[0];
    state.selectedHmis.otrasLetrasHMIS = datos.RadioProteccionMinuscula[0];
    //state.selectedHmis = hmis;
}

/**
 * Mutación que vacia la información guardada de HMIS en el formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} hmis contiene la información guardada de HMIS.
 */
export function resetHmis(state) {
    state.selectedHmis.opsalud = "";
    state.selectedHmis.ambiental = "";
    state.selectedHmis.saludHMIS = [];
    state.selectedHmis.inflamabilidad = "";
    state.selectedHmis.fisico = "";
    state.selectedHmis.peligrosHMIS = [];
    state.selectedHmis.letrasHMIS = [];
    state.selectedHmis.otrasLetrasHMIS = [];
    //state.selectedHmis = hmis;
}

/**
 *
 */
export function opcionesHmis(state) {

    //salud
    if (state.selectedHmis.saludHMIS == "") {
        for (var i = 0; i < state.selectedHmis.salud.length; i++) {
            state.selectedHmis.saludHMIS.push({ salud: state.selectedHmis.saludbd[i], label: state.selectedHmis.salud[i], valor: 'No' });
        }
    } else {
        for (i = 0; i < state.selectedHmis.salud.length; i++) {
            state.selectedHmis.saludHMIS[i].label = state.selectedHmis.salud[i];
        }

    }

    //Define peligros fisicos
    if (state.selectedHmis.peligrosHMIS == "") {
        for (var a = 0; a < state.selectedHmis.peligros.length; a++) {
            state.selectedHmis.peligrosHMIS.push({ peligro: state.selectedHmis.peligrosbd[a], label: state.selectedHmis.peligros[a], valor: 'No' });
        }
    } else {
        for (a = 0; a < state.selectedHmis.peligros.length; a++) {
            state.selectedHmis.peligrosHMIS[a].label = state.selectedHmis.peligros[a];
        }
    }

    //Define Letras
    if (state.selectedHmis.letrasHMIS == "") {
        for (var e = 0; e < state.selectedHmis.letras.length; e++) {
            state.selectedHmis.letrasHMIS.push({ letra: state.selectedHmis.letras[e], valor: 'No' });
        }
    }

    //Define Otras letras
    if (state.selectedHmis.otrasLetrasHMIS == "") {
        for (var o = 0; o < state.selectedHmis.otrasLetras.length; o++) {
            state.selectedHmis.otrasLetrasHMIS.push({ letra: state.selectedHmis.otrasLetras[o], valor: 'No' });
        }
    }

    //Define Ambiental
        //for (var u = 0; u < state.selectedHmis.ambiental.length; u++) {
    state.selectedHmis.ambientalHMIS.push({ value: 1, text: state.selectedHmis.ambiental });
    //}
}
